import CorporateCourseMenuRedirectMiddleware from '@/middleware/CorporateCourseMenuRedirectMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'course-attempt-authorizations-view',
        path: '/courses/:courseId/attempt-authorizations',
        component: () => import('@/pages/courses/attempt-authorizations/AttemptAuthorizationsIndex.vue'),
        beforeEnter: CorporateCourseMenuRedirectMiddleware,
        props: route => ({
            courseId: Number.parseInt(route.params.courseId, 10),
        }),
        meta: {
            title: 'Attempt Authorizations',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'attempt authorizations' },
        },
    },
];
